import { useEffect, useState } from 'react'

/**
 * Provides a searchTerm and setSearchTerm that are debounced: updates to searchTerm will only occur after delayMs milliseconds.
 * This prevents hammering the backend when typed input is being used for search, since the search will only occur after a user
 * stops typing for delayMs milliseconds.
 * @param delayMs Milliseconds to use for the debounce interval
 * @param initialValue Seeds both the box and the first query, for a search arriving from a deep link
 */
export function useDebouncedSearch(delayMs: number = 500, initialValue = '') {
  const [searchTerm, setSearchTerm] = useState<string>(initialValue)
  const [debouncedSearchTerm, setDebouncedSearchTerm] =
    useState<string>(initialValue)

  useEffect(() => {
    const handler = setTimeout(
      () => setDebouncedSearchTerm(searchTerm),
      delayMs,
    )
    return () => clearTimeout(handler)
  }, [searchTerm])

  return {
    searchTerm: debouncedSearchTerm,
    setSearchTerm: setSearchTerm,
    /** What has actually been typed, for a search box that has to be
     * controlled because something other than typing can set it. */
    inputValue: searchTerm,
  }
}
